import { FeatureAppNames } from './app-constants';
import { ModelOverviewIntegratorOptions } from './create-options-from-query-params';
import { createQSGConfig, defaultAppConfig } from './default-app-config';

const getCreateFunctionInstance = (featureAppName: string | undefined) => {
  switch (featureAppName) {
    case FeatureAppNames.DEFAULT:
    case FeatureAppNames.QUICK_START_GUIDE:
    default:
      return createQSGConfig;
  }
};

export const getConfigsFeatureApp = ({
  featureAppName,
  ...props
}: ModelOverviewIntegratorOptions) => {
  const createFunctionInstance = getCreateFunctionInstance(featureAppName);
  return createFunctionInstance(props);
};

export const contentFeatureAppMap = {
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appContent,
  [FeatureAppNames.QUICK_START_GUIDE]: defaultAppConfig.appContent,
};
